/**
 * Locales in this list will show the "enhanced" contact experience
 * with an alternative layout when focus=topics.
 * Keep this in alphabetical order to keep it tidy.
 */
// eslint-disable-next-line import/prefer-default-export
export const enabledEnhancedContactLocales = [
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-HK',
  'en-IE',
  'en-IN',
  'en-MY',
  'en-NZ',
  'en-PH',
  'en-US',
  'en-ZA',
  'es-AR',
  'es-CL',
  'es-MX',
  'es-ES',
  'fi-FI',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-FR',
  'hr-HR',
  'it-IT',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'sl-SI',
  'sv-SE',
];
